import {getServerLink} from '../helpers';
import Tags from './tags';

const PressComponent = () => {
  const root = document.querySelector('.press, .media-page');

  if (root) {
    new Tags(getServerLink(root.dataset.api));
  }

  if (document.querySelector('.press-center')) {
    new Tags(null);
  }
};

export const Press = () => {
  $(document).ready(() => PressComponent());
};
